export default "__VITE_ASSET__xgg1blrI__"